
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employers/synergy-scientific-solutions",
      function () {
        return require("private-next-pages/employers/synergy-scientific-solutions/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employers/synergy-scientific-solutions"])
      });
    }
  